import { StyledIcon } from './index.style'

export const ShareIcon = () => {
  return (
    <StyledIcon
      viewBox='0 0 30 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='30' height='30' rx='15' fill='black' fillOpacity='0.4' />
      <path
        d='M23.25 15L16.65 8.25V11.625C13.35 11.625 6.75 13.65 6.75 21.75C6.75 20.6247 8.73 18.375 16.65 18.375V21.75L23.25 15Z'
        stroke='white'
        strokeWidth='1.125'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </StyledIcon>
  )
}
